import { plainToClass } from 'class-transformer';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import { ClassType } from 'class-transformer/ClassTransformer';

export class BaseService {

	readonly http: AxiosInstance;

	constructor(http: AxiosInstance) {
		this.http = http;
	}

	protected async mapResponse<E>(httpResponse: Promise<AxiosResponse>, entityClass?: ClassType<any>): Promise<E> {
		try {
			const res = await httpResponse;
			return entityClass ? plainToClass(entityClass, res.data) : res.data;
		} catch (err) {
			const error = err as AxiosError;
			if (error && error.config.responseType === 'blob') {
				if (error.response) {
					const blob: Blob = error.response.data;
					const blobText = await blob.text();
					error.response.data = JSON.parse(blobText);
				}
			}
			throw error.response ? error.response : error;
		}
	}
}